import { render, staticRenderFns } from "./recruitmentAndSelection.vue?vue&type=template&id=4fa42522&scoped=true"
import script from "./recruitmentAndSelection.vue?vue&type=script&lang=js"
export * from "./recruitmentAndSelection.vue?vue&type=script&lang=js"
import style0 from "./recruitmentAndSelection.vue?vue&type=style&index=0&id=4fa42522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa42522",
  null
  
)

export default component.exports